import apiClient from './client';

export const knowledgeApi = {
  // Browse: list reports with PMEST filters (paginated)
  listReports: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/reports', { params });
    return response.data;
  },

  // Detail: single report with all VDB chunks
  getReport: async (fileId) => {
    const response = await apiClient.get(`/api/v1/knowledge/reports/${fileId}`);
    return response.data;
  },

  // Search: semantic + keyword hybrid with PMEST filters
  searchKnowledge: async (params = {}) => {
    const response = await apiClient.post('/api/v1/knowledge/search', params, {
      timeout: 60000,
    });
    return response.data;
  },

  // Stats: aggregate counts by any PMEST dimension
  getStats: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/stats', { params });
    return response.data;
  },

  // Sources: publisher inventory by tier
  getSources: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/sources', { params });
    return response.data;
  },

  // Filters: all available filter values (for dropdowns)
  getFilters: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/filters', { params });
    return response.data;
  },

  // Timeline: reports by year with source breakdown
  getTimeline: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/timeline', { params });
    return response.data;
  },

  // Source Intelligence endpoints
  getTopicTrends: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/intelligence/topic-trends', { params });
    return response.data;
  },

  getEntityVelocity: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/intelligence/entity-velocity', { params });
    return response.data;
  },

  getGeoShifts: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/intelligence/geo-shifts', { params });
    return response.data;
  },

  getTierComposition: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/intelligence/tier-composition', { params });
    return response.data;
  },

  getConvergence: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/intelligence/convergence', { params });
    return response.data;
  },

  // Cross-Validation endpoints
  getValidationHeadlineMetrics: async () => {
    const response = await apiClient.get('/api/v1/knowledge/validation/headline-metrics');
    return response.data;
  },

  getValidationMetrics: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/validation/metrics', { params });
    return response.data;
  },

  getValidationClaims: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/validation/claims', { params });
    return response.data;
  },

  getValidationScopes: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/validation/scopes', { params });
    return response.data;
  },

  getValidationAgreementMatrix: async () => {
    const response = await apiClient.get('/api/v1/knowledge/validation/agreement-matrix');
    return response.data;
  },

  // Clusters: claims grouped by scope for cross-source comparison
  getValidationClusters: async (params = {}) => {
    const response = await apiClient.get('/api/v1/knowledge/validation/clusters', { params });
    return response.data;
  },

  // Flag: report data quality issues to centralized Feedback Loop Sheet
  flagIssue: async (data) => {
    const response = await apiClient.post('/api/v1/knowledge/flag', data);
    return response.data;
  },

  // Review: human-in-the-loop feedback on report classification
  updateReportReview: async (fileId, updates) => {
    const response = await apiClient.patch(
      `/api/v1/knowledge/reports/${encodeURIComponent(fileId)}`,
      updates
    );
    return response.data;
  },

  // Ingestion Audit: check which GDrive file IDs are ingested into the index.
  // Backs the Ingestion Audit tab; mirrors Hyrule MCP tool
  // `check_ingestion_coverage` so MCP and FE share the same primitive.
  checkIngestionCoverage: async (data) => {
    const response = await apiClient.post('/api/v1/knowledge/coverage', data, {
      timeout: 60000,
    });
    return response.data;
  },

  // GDrive folder listing — used by the Ingestion Audit input flow to turn a
  // pasted folder URL into the file-ID list passed to checkIngestionCoverage.
  // Reuses Hyrule's existing /api/v1/gdrive/read/folder endpoint; no new
  // backend surface needed.
  readGdriveFolder: async (data) => {
    const response = await apiClient.post('/api/v1/gdrive/read/folder', data, {
      timeout: 60000,
    });
    return response.data;
  },
};
